module.exports = __webpack_public_path__ + "img/icon_1224.7d399ca7.svg";